import { buildBodyParentMap } from "../utils/bodyHierarchy";
import { getSceneState } from "../stores/sceneStore";
import type { BodyUUID } from "../types/scene";

export function resolveTopmostAncestorBodyUuid(
  scene: ReturnType<typeof getSceneState>,
  start: BodyUUID
): BodyUUID | null {
  try {
    const bodies = scene?.bodies || {};
    if (!start || !bodies[start]) return null;
    const parentMap = buildBodyParentMap(bodies);
    const seen = new Set<string>();
    let current: BodyUUID | null = start;
    while (current && !seen.has(String(current))) {
      seen.add(String(current));
      const parent = parentMap[current] ?? null;
      if (!parent) return current;
      current = parent as BodyUUID;
    }
    return start;
  } catch {
    return null;
  }
}
